const LABEL = '(?!-)[a-z\\d-]{1,63}(?<!-)';
const HOSTNAME_RE = new RegExp(`^(${LABEL}\\.)+([a-z]{2,63}|xn--[a-z\\d-]{1,59})$`, 'i');

export function normalizeSpecialistUrl(raw: string): string | null {
  const value = raw.trim();
  if (!value || /\s/.test(value)) return null;

  const withScheme = /^[a-z][a-z\d+.-]*:\/\//i.test(value) ? value : `https://${value}`;

  let url: URL;
  try {
    url = new URL(withScheme);
  } catch {
    return null;
  }

  if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
  if (url.username || url.password) return null;
  if (!HOSTNAME_RE.test(url.hostname)) return null;

  return url.toString();
}
